/**
 * Allowed attachment MIME types for QualityManagementFeedback
 */
export default [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
];
